import gql from 'graphql-tag';

export const AFTERMARKET_PRODUCTS_LIST = gql`
  query GetAftermarketProducts($accountId: ID!, $activeOnly: Boolean, $availableOnly: Boolean) {
    aftermarketProducts(accountId: $accountId, activeOnly: $activeOnly, availableOnly: $availableOnly) {
      aftermarketProductId
      isActive
      productName
      aftermarketVendorApiChannel
      partnerLinks {
        partnerLinkId
        name
        partnerProfile {
          id
          accountName
        }
      }
      productCategory
      productDescriptionExternal
      criteria
      productDescriptionInternal
      productType
      createdDateTime
      sourceOfCreation
      createdBy {
        id
        name
      }
    }
  }
`;
